
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateTimeBlockTemplateDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    description: new FormControl<string | undefined>(undefined),
    isActive: new FormControl<boolean | undefined>(true),
})
;
}
      